// Slugs already used in the codebase for payment routes.
export enum PaymentSlug {
  Online = 'online-payment',
  COD = 'cash-on-delivery',
}

export interface PaymentMethodSummary {
  // Human-readable phrase used in the banner copy (`{0}` slot in OfferNoticeText).
  label: string;
  // Preferred slug for the Claim Offer CTA. COD wins when both are available
  // so the checkout defaults to the cheaper-of-two fulfillment paths.
  defaultSlug: string;
}

// Phrase + default-slug builder — derives both fields from the IPaymentType[]
// array returned by /api/payment/options. Reuses the existing IPaymentType shape; no new types.
export const buildPaymentMethodSummary = (
  paymentTypes: { Slug: string }[],
): PaymentMethodSummary | null => {
  const slugs = new Set(paymentTypes.map((p) => p.Slug));
  const hasOnline = slugs.has(PaymentSlug.Online);
  const hasCOD = slugs.has(PaymentSlug.COD);

  if (hasOnline && hasCOD) {
    return { label: 'online or cash on delivery', defaultSlug: PaymentSlug.COD };
  }

  if (hasOnline) {
    return { label: 'online', defaultSlug: PaymentSlug.Online };
  }

  if (hasCOD) {
    return { label: 'cash on delivery', defaultSlug: PaymentSlug.COD };
  }
  
  return null;
};